import { HomeProductsCarousel } from "@/components/organisms"
import { MeilisearchProductsCarousel } from "@/components/organisms/HomeProductsCarousel/MeilisearchProductsCarousel"
import { getRegion } from "@/lib/data/regions"
import { Product } from "@/types/product"

const ALGOLIA_ID = process.env.NEXT_PUBLIC_ALGOLIA_ID
const ALGOLIA_SEARCH_KEY = process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY
const USE_LOCAL_SEARCH = !!process.env.NEXT_PUBLIC_USE_LOCAL_SEARCH

export const HomeProductSection = async ({
  heading,
  locale = process.env.NEXT_PUBLIC_DEFAULT_REGION || "pl",
  products = [],
  home = false,
  seller_handle,
}: {
  heading: string
  locale?: string
  products?: Product[]
  home?: boolean
  seller_handle?: string
}) => {
  const currency_code = (await getRegion(locale))?.currency_code || "usd"

  return (
    <section className="py-[40px] w-full">
      <h2 className="mb-8 heading-lg font-bold tracking-tight uppercase">
        {heading}
      </h2>
      {
        USE_LOCAL_SEARCH ? <HomeProductsCarousel
          locale={locale}
          sellerProducts={products.slice(0, 18)}
          home={home}
        /> : <MeilisearchProductsCarousel
          locale={locale}
          rows={4}
          showProductCount={32}
          random={true}
          currency_code={currency_code}
          seller_handle={seller_handle}
        />
      }
    </section>
  )
}